import { ref, watchEffect } from 'vue';
import type { OptionsItem } from '../../select/types';
import type { EnumBaseProps } from '../types';
import { EnumRadioProps, EnumToObject } from '../types';

/*
 * @Description:
 * @Author: luckymiaow
 * @Date: 2022-05-09 11:20:27
 * @LastEditors: luckymiaow
 */
export function enumToObject(enumData: any): OptionsItem<any>[] {
  let data: OptionsItem<any>[] = [];
  let regPos = /^(0|[1-9][0-9]*|-[1-9][0-9]*)$/;
  for (let key in enumData) {
    if (!regPos.test(key)) {
      data.push({ value: enumData[key], label: key });
    }
  }
  return data;
}

export default ({ props }: { props: EnumBaseProps }) => {
  const options = ref<OptionsItem<any>[]>([]);

  watchEffect(() => {
    const data = enumToObject(props.enum);

    if (props.appointOptions) {
      options.value = data.filter(e => props.appointOptions!.includes(e.value));
    } else if (props.excludeOptions) {
      options.value = data.filter(e => !props.excludeOptions!.includes(e.value));
    } else {
      options.value = data;
    }
  });

  return { options };
};
